export default __webpack_public_path__ + "static/media/pink360.56c43402.gif";